<!--begin::User info-->
<div class="btn btn-flex align-items-center bg-hover-white bg-hover-opacity-10 py-2 ps-2 pe-2 me-n2" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">

	<!--begin::Name-->
	<div class="d-none d-md-flex flex-column align-items-end justify-content-center me-2 me-md-4" *ngIf="isLoggedIn && user">
		<span class="text-white opacity-75 fs-8 fw-semibold lh-1 mb-1">{{ getUserDisplayName() }}</span>
		<span class="text-white fs-8 fw-bold lh-1">{{ getUserRole() }}</span>
	</div>
	<!--end::Name-->

	<!--begin::Symbol-->
	<div class="cursor-pointer symbol symbol-35px">
		<img [src]="getUserAvatar()" class="rounded-3" alt="user" />
	</div>
	<!--end::Symbol-->
</div>
<!--end::User info-->
<!--begin::User account menu-->
<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px" data-kt-menu="true">
	<!--begin::Menu item-->
	<div class="menu-item px-3" *ngIf="isLoggedIn && user">
		<div class="menu-content d-flex align-items-center px-3">
			<!--begin::Avatar-->
			<div class="symbol symbol-50px me-5">
				<img alt="User Avatar" [src]="getUserAvatar()" />
			</div>
			<!--end::Avatar-->
			<!--begin::Username-->
			<div class="d-flex flex-column">
				<div class="fw-bold d-flex align-items-center fs-5">{{ getUserDisplayName() }}
					<span class="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2" *ngIf="user.isPro">Pro</span>
				</div>
				<a href="#" class="fw-semibold text-muted text-hover-primary fs-7">{{ getUserEmail() }}</a>
			</div>
			<!--end::Username-->
		</div>
	</div>
	<!--end::Menu item-->
	<!--begin::Menu separator-->
	<div class="separator my-2"></div>
	<!--end::Menu separator-->
	<!--begin::Menu item-->
	<div class="menu-item px-5">
		<a [routerLink]="['/profile']" class="menu-link px-5">My Profile</a>
	</div>
	<!--end::Menu item-->
	<!--begin::Menu item-->
	<!-- <div class="menu-item px-5">
		<a href="apps/projects/list.html" class="menu-link px-5">
			<span class="menu-text">My Projects</span>
			<span class="menu-badge">
				<span class="badge badge-light-danger badge-circle fw-bold fs-7">3</span>
			</span>
		</a>
	</div> -->
	<!--end::Menu item-->
	<!--begin::Menu item-->

	<!--end::Menu item-->
	<!--begin::Menu item-->
	<div class="menu-item px-5">
		<a href="javascript:;" (click)="logout()" class="menu-link px-5">Sign Out</a>
	</div>
	<!--end::Menu item-->
	<!--end::User account menu-->
	<!--end::Menu wrapper-->
</div>
